import { Document } from "@react-pdf/renderer";
import { payments } from "lobbie";
import React from "react";
import { ECareResourceType } from "src/types/global_enums";
import InvoicePage from "./InvoicePage";
import InvoicePageContent from "./InvoicePageContent";
import InvoiceTotals from "./InvoiceTotals";

interface IProps {
    invoiceDetails: payments.print.IInvoicePrintData;
}

const Invoice: React.FC<IProps> = ({ invoiceDetails }) => {
    // Extract data from invoiceDetails
    const { invoiceLineItems, business, logoUrl, receiptDetails, isCanada, timezone, taxSettings } =
        invoiceDetails;
    // Split line items into services and items based on careResourceType
    const services = invoiceLineItems.filter(
        (item) => item.careResourceType === ECareResourceType.SERVICE,
    );
    const items = invoiceLineItems.filter(
        (item) =>
            item.careResourceType === ECareResourceType.CONSUMABLE ||
            item.careResourceType === ECareResourceType.EQUIPMENT,
    );
    // Check for taxed items
    const taxedLineItems = invoiceLineItems.filter((item) => {
        return item.applySalesTax;
    });
    // Check that taxes are active at this location and that there are taxed items in the invoice to display tax info in the pdf
    const applyTax: boolean =
        isCanada && (taxSettings?.active ?? false) && taxedLineItems.length > 0;
    const hasSubscription: boolean =
        !!invoiceDetails.recurringPayments && invoiceDetails.recurringPayments.length > 0;
    return (
        <Document>
            <InvoicePage
                invoiceDetails={invoiceDetails}
                logoUrl={logoUrl}
                business={business}
                receiptDetails={receiptDetails}
                timezone={timezone}
            >
                <InvoicePageContent
                    services={services}
                    items={items}
                    applyTax={applyTax}
                    hasSubscription={hasSubscription}
                    isReceipt={!!receiptDetails}
                />
                <InvoiceTotals
                    invoiceDetails={invoiceDetails}
                    applyTax={applyTax}
                    receiptDetails={receiptDetails}
                />
            </InvoicePage>
        </Document>
    );
};

export default Invoice;
